import { useState } from 'react'
import { Box, Skeleton } from '@mui/material';
import { avatarstylesxx } from "../../core/styling/global"

export const MediaLoader = ({image, width, height}) => {
    const [loaded, setLoaded] = useState(false)
    
    let img = document.createElement('img');
    img.src = image;
    img.addEventListener('load', e => {
        setLoaded(true)
        img = null;
    });
    
    return loaded ? (
        <Box borderRadius={4} bgcolor="#ccc" width={width} height={height} >
            <Box sx={avatarstylesxx(image, '100%', '100%', '16px' )} />
        </Box>
    ) : (
        <Skeleton variant="rect" width={width} height="100%" style={{borderRadius: '12px', backgroundColor: '#DBEDFD'}} />
    )
}